import React from 'react';
import { FaPlane } from 'react-icons/fa';
import UnifiedStarBackground from './UnifiedStarBackground';
import '../styles/Loader.css';

const Loader: React.FC = () => {
  return (
    <div className="loader-container">
      <UnifiedStarBackground variant="primary" />
      <div className="loader">
        <div className="spinner-container">
          <div className="outer-circle">
            <div className="inner-circle">
              <FaPlane className="plane-icon" />
            </div>
          </div>
          <svg className="spinner-track" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="45" />
          </svg>
          <svg className="spinner-progress" viewBox="0 0 100 100">
            <circle cx="50" cy="50" r="45" />
          </svg>
        </div>
        <div className="loading-text">
          <span>Loading</span>
          <span className="dots">
            <span>.</span>
            <span>.</span>
            <span>.</span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default Loader;